export enum DecohabitationStatus {
  NotWished = 'Non souhaitée',
  WishedInProgress = 'Souhaitée, en cours',
  Wished = 'Souhaitée',
}
